export const mutations = {
  MutationUpdatePeakGuide(state, status) {
    state.updatePeakGuide = status;
  },
  MutationGetPeakGuide(state, status) {
    state.getPeakGuide = status;
  },
  MutationUpdatePeakGuideLoadingStatus(state, status) {
    state.updatePeakGuideLoadingStatus = status;
  },
  MutationGetPeakGuideLoadingStatus(state, status) {
    state.getPeakGuideLoadingStatus = status;
  },
  MutationSetShowPeakGuide(state, status) {
    state.showPeakGuide = status;
  },
};
